import { Cookies} from 'react-cookie';
import { routerAppName, routerCustomerId } from '../../helpers/utils';

const cookies = new Cookies();

const get = (key: string, def?: string): string => {
    try {
        const rtn = window.localStorage.getItem(createKey(key));
        if (rtn == null || rtn === 'null' || rtn === 'undefined')
            return def || '';

        return rtn;
    } catch(err) {
        console.log("browser setting error with local storage disabled!"); // NOSONAR
        return def || '';
    }
}

const set = (key: string, item: string) => {
    try {
        window.localStorage.setItem(createKey(key), item);
    } catch (err) {
        console.log("browser setting error with local storage disabled!"); // NOSONAR
    }
}

const createKey = (key: string): string => {
    return routerCustomerId + '/' + key;
}

const remove = (key: string) => {
    window.localStorage.removeItem(createKey(key));
}

const uuid = () => {
    var fmt = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return fmt.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-mixed-operators
        var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
        return v.toString(16);
    });
}

export const getBrowserId = () => {
    let browserId = get('browserId');
    if(!browserId) {
        browserId = uuid();
        window.localStorage.browserId = browserId;
    }
    return browserId;
}

export const getUsername = (): string => {
    return get('username');
}

export const saveUsername = (username: string): void => {
    set('username', username);
}
export const removeUsername = (): void => {
    remove('username');
}

export const getToken = (): string => {
    return cookies.get('ctxlogintoken!');
}

export const getPasscodeToken = (): string => {
    return cookies.get(routerAppName);
}

const cookieOptions = () => {
    return {
        path: `/${routerCustomerId}`,
        // eslint-disable-next-line no-restricted-globals
        secure: location.protocol === 'https'
    };
}

export const saveToken = (token: string): void => {
    cookies.set('ctxlogintoken!', token, cookieOptions());
}

export const savePasscodeToken = (token: string): void => {
    cookies.set(routerAppName, token, cookieOptions());
}

export const removeToken = (): void => {
    cookies.remove('ctxlogintoken!', cookieOptions());
}

export const removePasscodeToken = (): void => {
    cookies.remove(routerAppName, cookieOptions());
}
